import dateFormat from 'dateformat'
import dayjs from 'dayjs'
import { getWorkspaceTimezone } from 'libs/date'

export const timestampFormat = (timestamp, format = 'mmm d, yyyy') => {
  return dateFormat(timestamp, format)
}

export const timezoneAwareTimestampFormat = (timestamp, format = 'MMM D, YYYY') => {
  const workspaceTimezone = getWorkspaceTimezone()
  return dayjs(timestamp).tz(workspaceTimezone).format(format)
}

export function fullDateTimeFormat(date) {
  return customFullDateTimeFormat(date)
}

export function formatCustomAttributeDatetime(value) {
  if (!value) {
    return null
  }
  const d = dayjs(value)
  return d.isValid() ? d.format('MMM D, YYYY') : null
}

export function customFullDateTimeFormat(timestamp) {
  const dateTime = timezoneAwareTimestampFormat(timestamp, 'MMM D, YYYY, h:mm:ss A (UTCZ)')
  return dateTime
}

export function shortRelativeFormat(time) {
  const date = new Date(time || '')
  const now = new Date().getTime()
  const diff = (now - date.getTime()) / 1000
  const day_diff = Math.floor(diff / 86400)

  if (isNaN(day_diff) || day_diff < 0) {
    return
  }

  const SECONDS_IN_MINUTE = 60
  const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60
  const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24

  if (diff < SECONDS_IN_MINUTE) {
    return 'now'
  }

  if (diff < SECONDS_IN_MINUTE * 2) {
    return '1m'
  }

  if (diff < SECONDS_IN_HOUR) {
    return Math.round(diff / SECONDS_IN_MINUTE) + 'm'
  }

  if (diff < SECONDS_IN_DAY) {
    return Math.round(diff / SECONDS_IN_HOUR) + 'h'
  }

  if (diff < SECONDS_IN_DAY * 5.5) {
    return Math.round(diff / SECONDS_IN_DAY) + 'd'
  }

  return timestampFormat(time, 'd mmm')
}

export const relativeDateTimeFormat = (timestamp) => {
  return customRelativeDateTimeFormat(timestamp)
}

export const customRelativeDateTimeFormat = (timestamp) => {
  const currentTime = dayjs()
  const answeredTime = dayjs(timestamp)

  const diffSeconds = currentTime.diff(answeredTime, 'second')
  const diffMinutes = currentTime.diff(answeredTime, 'minute')
  const diffHours = currentTime.diff(answeredTime, 'hour')
  const diffDays = currentTime.diff(answeredTime, 'day')

  // < 1 minute
  if (diffSeconds < 60) {
    return 'A few seconds ago'
  }

  // 60-119 seconds (1-2 minutes)
  if (diffSeconds < 120) {
    return 'a minute ago'
  }

  // < 60 minutes
  if (diffMinutes < 60) {
    return `${diffMinutes} minutes ago`
  }

  // < 24 hours
  if (diffHours < 24) {
    return `${diffHours} hour${diffHours === 1 ? '' : 's'} ago`
  }

  // < 7 days
  if (diffDays < 7) {
    return `${diffDays} day${diffDays === 1 ? '' : 's'} ago`
  }

  // ≥ 7 days
  return timezoneAwareTimestampFormat(timestamp, 'MMM D, YYYY')
}

export const convertIsoOffsetToUTC = (
  startDate,
  endDate,
  isLocalTimezone = false,
  isTimeSerieChart = false
) => {
  if (isLocalTimezone && isTimeSerieChart) {
    // Extract just the date part (YYYY-MM-DD)
    const startDateOnly = startDate.slice(0, 10)
    const endDateOnly = endDate.slice(0, 10)

    const start = new Date(`${startDateOnly}T00:00:00Z`)
    const end = new Date(`${endDateOnly}T23:59:59.999Z`)

    startDate = start.toISOString()
    endDate = end.toISOString()
  }

  return { startDate, endDate }
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/libs/date-format/index.js